import React, { useState } from "react";
import KuikaEmptyState from "../../../../ui-kit/kuika-empty-state/kuika-empty-state";
import KuikaInput from "../../../../ui-kit/kuika-input/kuika-input";
import KuikaListPage, {
  KuikaCreateCard,
  KuikaCreateCardRow,
  KuikaListPageHeader,
  KuikaListPageToolbar
} from "../../../../ui-kit/kuika-list-page/kuika-list-page";
import KuikaSvg from "../../../../ui-kit/kuika-svg/kuika-svg";
import KuikaTabs from "../../../../ui-kit/kuika-tabs/kuika-tabs";
import { ShowcaseFrame } from "../_layout/showcase-frame";
import { SpecRow } from "../_layout/spec-row";

const TABS: string[] = ["Jobs", "Templates"];

// A tool landing page as the scheduled-jobs panel builds it: header, create cards, toolbar, body.
const LandingPage: React.FC = (): JSX.Element => {
  const [tab, setTab] = useState<string>(TABS[0]);
  const [isCreating, setIsCreating] = useState<boolean>(false);
  return (
    <div style={{ position: "relative", width: "100%", height: 520, border: "var(--border)" }}>
      <KuikaListPage>
        <KuikaListPageHeader
          icon={<KuikaSvg name="scheduled-jobs" type="topbar-icons" width={20} height={20} />}
          title="Scheduled Jobs"
        />
        <KuikaCreateCardRow>
          <KuikaCreateCard
            title="Create a blank job"
            description="Click to watch the card work while it creates."
            icon={<KuikaSvg name="plus" />}
            iconBackground="var(--blue-1)"
            iconColor="var(--accent-fg)"
            loading={isCreating}
            onClick={(): void => setIsCreating(!isCreating)}
          />
          <KuikaCreateCard
            title="From template"
            description="Start from a ready-made schedule."
            icon={<KuikaSvg name="repeat" />}
            iconBackground="var(--purple-1)"
            iconColor="var(--purple-5)"
            onClick={(): void => setTab(TABS[1])}
          />
          <KuikaCreateCard
            title="Import"
            description="Unavailable here — dims to the disabled token."
            icon={<KuikaSvg name="layout-rows" />}
            disabled
            onClick={(): void => undefined}
          />
        </KuikaCreateCardRow>
        <KuikaListPageToolbar
          tabs={<KuikaTabs size="lg" options={TABS} value={tab} onChange={(value: string): void => setTab(value)} />}
          search={<KuikaInput size="md" placeholder="Search by name..." />}
        />
        <KuikaEmptyState
          svgName="clock"
          customName="No jobs yet"
          description="Create one above; it will be listed here."
          variant="page"
        />
      </KuikaListPage>
    </div>
  );
};

export const ListPageStory: React.FC = (): JSX.Element => {
  return (
    <ShowcaseFrame
      title="List Page"
      componentName="KuikaListPage"
      sourcePath="ui-kit/kuika-list-page"
      description="The tool-landing shell: icon-led header, a row of create cards, a tabs/search/filters toolbar and the panel's own body. The create card's icon sits on the kit's icon tile (48px, radius 12)."
    >
      <SpecRow
        label="Landing page"
        caption="create card: hover lifts the border, keyboard focus rings it, loading keeps full strength with a progress cursor, disabled dims"
        align="stretch"
      >
        <LandingPage />
      </SpecRow>
    </ShowcaseFrame>
  );
};
